/**
 * The seam's one error shape (ADR-020 §7 fail-loud contract): every refusal
 * carries the full list of reasons — a caller surfaces them verbatim, never a
 * partial file, never a silent skip. Mirrors GlbExportError's posture in
 * adapter-three, without depending on it (this package is engine-free).
 * Depends on: nothing. Depended on by: every module here.
 */
export class TextureMasterError extends Error {
  readonly reasons: readonly string[];

  constructor(reasons: readonly string[]) {
    super(`texture-master refused:\n${reasons.map((r) => ` - ${r}`).join('\n')}`);
    this.name = 'TextureMasterError';
    this.reasons = reasons;
  }
}
